export default {
  showPhysicians: false,
  allowPhysicianRegistration: false,
  showRealtors: false,
}
